module.exports = __webpack_public_path__ + "static/media/Medium.9428b4ec.svg";